import { Ticker } from "pixi.js"

export type ClockCallbackObject = {
  startTime: number
  time: number
  repeat: boolean
  callback: () => void
}

export default class Clock {
  static elapsedTime = 0

  private static _callbacks: {
    startTime: number
    time: number
    repeat: boolean
    callback: () => void
  }[] = []

  static tick(ticker: Ticker) {
    Clock.elapsedTime += ticker.elapsedMS
    const cbToRemove = []
    for (const cb of Clock._callbacks) {
      const delta = Clock.elapsedTime - cb.startTime
      if (delta >= cb.time) {
        cb.callback()
        if (cb.repeat) {
          cb.startTime = Clock.elapsedTime
        } else {
          cbToRemove.push(cb)
        }
      }
    }
    for (const cb of cbToRemove) {
      const index = Clock._callbacks.indexOf(cb)
      if (index >= 0) {
        Clock._callbacks.splice(index, 1)
      }
    }
  }

  static setTimeout(callback: () => void, time: number): ClockCallbackObject {
    const cb = {
      startTime: Clock.elapsedTime,
      time,
      callback,
      repeat: false
    }
    Clock._callbacks.push(cb)
    return cb
  }

  static setInterval(callback: () => void, time: number): ClockCallbackObject {
    const cb = {
      startTime: Clock.elapsedTime,
      time,
      callback,
      repeat: true
    }
    Clock._callbacks.push(cb)
    return cb
  }

  static clear(cb: ClockCallbackObject) {
    for (let i = 0; i < Clock._callbacks.length; i++) {
      if (Clock._callbacks[i] === cb) {
        Clock._callbacks.splice(i, 1)
        break
      }
    }
  }
}
